import { Component, Input } from '@angular/core';
import { RouteSheetLocationDTO } from '../../../organisms/route-sheet/models/RouteSheetLocationDTO';
import { RouteSheetService } from '../../../organisms/route-sheet/service/RouteSheet.service';

@Component({
  selector: 'route-sheet-unit-card',
  templateUrl: './unit-card.component.html',
  styleUrls: ['./unit-card.component.css']
})
export class UnitCardComponent {
  @Input() routeSheetLocation: RouteSheetLocationDTO;
  @Input() skeletonLoading: boolean = false;
  
  constructor(private routeSheetService: RouteSheetService) {}
}
